import React from 'react';

import { ColumnHeaderSortable } from '../../DataTable/index.jsx';

import Column from './base.jsx';


var columnOptions = {
  id: 't',
  title: 'Category'
};


class HeaderColumn extends ColumnHeaderSortable {
  get id() {
    return columnOptions.id;
  }

  get title() {
    return columnOptions.title;
  }
}


class DetailColumn extends React.Component {
  render() {
    return (
      <td>{this.props.row.category}</td>
    );
  }
}


class Category extends Column {
  get id() {
    return columnOptions.id;
  }

  get title() {
    return columnOptions.title;
  }

  sortAscending(a, b) {
    if (a.category < b.category) {
      return -1;
    }
    if (a.category > b.category) {
      return 1;
    }
    return super.sortAscending(a, b);
  }

  sortDescending(a, b) {
    if (a.category < b.category) {
      return 1;
    }
    if (a.category > b.category) {
      return -1;
    }
    return super.sortDescending(a, b);
  }

  get DetailColumn() {
    return DetailColumn;
  }

  get HeaderColumn() {
    return HeaderColumn;
  }
}


export default Category;

